import Header from '../components/Header';
import Footer from '../components/Footer';
import { president } from './Mandat';
import { contactRGPD } from './Mandat';

function MentionsLegales() {
  return (
    <div className="flex flex-col min-h-screen dark:bg-fond-sombre">
      <Header/>

      <main className="flex-grow max-w-4xl mx-auto p-6 space-y-6 mb-16">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gris-sombre dark:text-blanc-sombre text-center mt-12">Mentions légales</h1>
        <p className="text-1xl font-bold text-gray-800 dark:text-blanc-sombre text-center">Dernière mise à jour : 21 mars 2026</p>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Éditeur du site</h2>
          <p className="dark:text-blanc-sombre">
            Ingénierie et Conseil en Cognitique (i2c) est une Junior-Entreprise composée exclusivement d’étudiants de l’École Nationale Supérieure de Cognitique.
            Elle a pour vocation de compléter la formation théorique dispensée dans l’établissement
            par des applications pratiques en entreprise. i2c est une association à but non lucratif régie par la loi 1901
            et membre de la Confédération Nationale des Junior-Entreprises (CNJE).<br/>
            <br/>
            Adresse : 109 Avenue Roul, 33400 Talence<br/>
            Site : <a href="https://www.junior-i2c.com" className="text-blue-600 underline">https://www.junior-i2c.com</a><br/>
            Responsable de la publication : {president.nom}, {president.role.toLowerCase()} d'i2c<br/>
            N° SIRET : 495 329 310 00025<br/>
            N° RNA : W332003168<br/>
            Code APE : 82.99Z<br/>
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Hébergement du site</h2>
          <p className="dark:text-blanc-sombre">
            Hébergeur : OVHcloud<br/>
            Adresse : 2 Rue Kellermann, 59100 Roubaix<br/>
            Site web : <a href="https://www.ovhcloud.com" className="text-blue-600 underline">https://www.ovhcloud.com</a><br/>
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Propriété intellectuelle</h2>
          <p className="dark:text-blanc-sombre">
            Tous les contenus présents sur ce site, incluant textes, images, logos et vidéos, sont la propriété d'i2c ou de ses
            partenaires et sont protégés par le droit d'auteur. Toute reproduction, représentation ou diffusion partielle ou
            totale sans autorisation est interdite.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Données personnelles</h2>
          <p className="dark:text-blanc-sombre">
            Conformément au Règlement Général sur la Protection des Données (RGPD), les informations recueillies via ce site
            sont destinées uniquement à i2c pour traiter vos demandes. Vous disposez d’un droit d’accès, de portabilité,
            d'effacement, de rectification et d'opposition de vos données. 
            Pour exercer vos droits, contactez-nous à l’adresse e-mail : <a href={`mailto:${contactRGPD.mail}`} className="text-blue-600 underline">{contactRGPD.mail}</a>
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Liens et responsabilité</h2>
          <p className="dark:text-blanc-sombre">
            i2c ne saurait être tenue responsable des contenus des sites externes accessibles via des liens présents sur ce
            site. L’utilisation du site se fait sous votre entière responsabilité.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Droit applicable</h2>
          <p className="dark:text-blanc-sombre">
            Les présentes mentions légales sont régies par le droit français. 
            Tout litige relatif à l’utilisation du site sera soumis aux tribunaux compétents.
          </p>
        </section>
      </main>

      <Footer/>
    </div>
  );
}

export default MentionsLegales;